module.exports = __webpack_public_path__ + "246e806f349500683eee664c956ae134.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/proximanova-bold-webfont.ttf
// module id = 311
// module chunks = 0